import { render, staticRenderFns } from "./newAttributeGroup.vue?vue&type=template&id=a04bf1f0&scoped=true"
import script from "./newAttributeGroup.vue?vue&type=script&scoped=true&lang=js"
export * from "./newAttributeGroup.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./newAttributeGroup.vue?vue&type=style&index=0&id=a04bf1f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a04bf1f0",
  null
  
)

export default component.exports